function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.555 11.147H9.047a.491.491 0 00-.492.492v5.246a.492.492 0 00.492.492h9.508a.492.492 0 00.492-.492v-5.246a.491.491 0 00-.492-.492zm-.492 5.246H9.538v-4.262h8.525z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.263 18.033a.492.492 0 00-.492.492v.492H2.984V.984h7.541v4.754a.491.491 0 00.492.492h4.755v3.771a.492.492 0 00.984 0V5.739a.487.487 0 00-.054-.221l-.01-.019a.488.488 0 00-.084-.112L11.366.145a.521.521 0 00-.1-.078L11.24.053a.491.491 0 00-.12-.043h-.008a.494.494 0 00-.09-.009H2.831a.826.826 0 00-.826.825v18.35a.826.826 0 00.826.825H15.94a.822.822 0 00.82-.82v-.655a.492.492 0 00-.497-.493zM11.508 5.246V1.679l3.567 3.567z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.724 15.99a.491.491 0 00.678-.156l.4-.645.4.645a.492.492 0 00.834-.521l-.657-1.051.657-1.051a.492.492 0 00-.834-.521l-.4.645-.4-.645a.492.492 0 00-.834.521l.657 1.051-.657 1.051a.492.492 0 00.156.677zM10.361 13.442h.164v2.131a.492.492 0 00.984 0v-2.131h.164a.492.492 0 100-.983h-1.312a.492.492 0 100 .983zM15.935 13.442h.164v2.131a.492.492 0 00.984 0v-2.131h.164a.492.492 0 100-.983h-1.311a.492.492 0 100 .983z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z"
});

var SvgFileTxt = function SvgFileTxt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgFileTxt, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/FileTxt.24eebab8.svg";
export { ForwardRef as ReactComponent };